import connect3 from "./connect3";
import janet from "./janet";

export const themes: Record<string, Record<string, string>> = {
  connect3,
  janet,
};
